<div class="cockpit-content">
  <h1 translate>{{card.title}}</h1>
  <h2 translate>m1.sprint8.cockpit-kontrolle.modellvarianten.subtitle</h2>
  <app-chart-download-button (buttonClick)="exportRegressionOutput()">
    <h3 translate>m2.sprint4.cockpit.card.funktionenstatistiken.table</h3>
  </app-chart-download-button>
  <app-modellvarianten-regression-output-table [data]="data?.regressionOutput"></app-modellvarianten-regression-output-table>

  <app-chart-download-button (buttonClick)="exportKoeffizienteTable()">
    <h3 translate>m2.sprint4.cockpit.card.funktionenstatistiken.table</h3>
  </app-chart-download-button>
  <app-modellvarianten-koeffiziente-table [data]="data?.koeffiziente"></app-modellvarianten-koeffiziente-table>

  <div class=" pdb-50"></div>

  <h2 translate>m1.sprint8.cockpit-kontrolle.modellvarianten.drr-header</h2>
  <app-chart-download-button (buttonClick)="exportDrrTable()">
    <h3 translate>m2.sprint4.cockpit.card.funktionenstatistiken.table</h3>
  </app-chart-download-button>
  <app-modellvarianten-drr-table [data]="data?.doublyRobustRegression"></app-modellvarianten-drr-table>
</div>
